import gql from 'graphql-tag'

export const GET_THERMO = gql`
query ThermoTypes {
    thermoTypes {
      isSuccessful
      message
      thermoTypes {
        text
        hasRelation
        companyId
      }
    }
  }`

export const THERMO_MUTATION_CREATE = gql`
mutation MutationType($input: CreateLookupInputSimple!) {
    createThermoType(input: $input) {
      isSuccessful
      message
      thermoType {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`

export const THERMO_MUTATION_DELETE = gql`
mutation MutationType($input: DeleteLookupInputSimple!) {
  deleteThermoType(input: $input) {
    isSuccessful
    message
    thermoType {
      companyId
      srcTable
      srcColumn
      text
    }
  }
}`

export const THERMO_MUTATION_UPDATE = gql`
mutation MutationType($input: UpdateLookupInputSimple!) {
  updateThermoType(input: $input) {
    isSuccessful
    message
    thermoType {
      companyId
      srcTable
      srcColumn
      text
    }
  }
}
`
